import React from 'react';
import SvgIcon from '../SvgIconWrapper';

interface HBeamIconProps {
  size?: number;
  color?: string;
}

const HBeamIcon: React.FC<HBeamIconProps> = (props) => (
  <SvgIcon {...props} className="sx-icon-hbeam">
    {
      <path d="M21.126 19.614h-7.636c-0.525 0-0.896 0.067-0.896-0.458v-14.203c0-0.466 0.45-0.55 0.916-0.55h7.63v-1.388c0-0.065-3.773-0.117-3.837-0.117h-10.228c-4.215 0-4.215 0.052-4.215 0.117v1.388h8.003c0.454 0 0.815 0.096 0.815 0.55v14.218c0 0.49-0.4 0.443-0.891 0.443h-3.742c-0.065 0-4.2-0.065-4.2 0v1.371c0 0.065 4.15 0.117 4.215 0.117h10.228c0.065 0 3.837-0.052 3.837-0.117v-0.69c0-0.065 0.065-0.681 0-0.681z"></path>
    }  </SvgIcon>
);

export default HBeamIcon;
